/* Shared style objects. Kept out of ui.jsx so that file exports only
   components, which is what React Fast Refresh needs to hot-reload cleanly. */

import { COLORS, FONT_BODY } from "../theme.js";

export const inputStyle = {
  background: COLORS.blackSoft,
  border: `1px solid ${COLORS.line}`,
  borderRadius: 8,
  padding: "12px 13px",
  color: COLORS.cream,
  fontSize: 14,
  fontFamily: FONT_BODY,
  outline: "none",
  width: "100%",
  boxSizing: "border-box",
};

export const selectStyle = { ...inputStyle };

export const primaryBtnStyle = {
  flex: 1,
  background: `linear-gradient(145deg, ${COLORS.goldBright}, ${COLORS.gold})`,
  color: "#1A1408",
  border: "none",
  borderRadius: 9,
  padding: "14px 18px",
  fontSize: 14.5,
  fontWeight: 700,
  fontFamily: FONT_BODY,
  cursor: "pointer",
};

export const secondaryBtnStyle = {
  flex: 1,
  background: "transparent",
  color: COLORS.cream,
  border: `1px solid ${COLORS.line}`,
  borderRadius: 9,
  padding: "14px 18px",
  fontSize: 14.5,
  fontWeight: 600,
  fontFamily: FONT_BODY,
  cursor: "pointer",
};

export const ghostBtnStyle = {
  background: "transparent",
  color: COLORS.creamDim,
  border: "none",
  fontFamily: FONT_BODY,
  fontSize: 14,
  cursor: "pointer",
};

/** Applies the disabled look consistently instead of repeating opacity/cursor everywhere. */
export function btnState(style, enabled) {
  return { ...style, opacity: enabled ? 1 : 0.45, cursor: enabled ? "pointer" : "not-allowed" };
}
